// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.gradient[data-v-5942eb48] {\n  background: rgb(2, 0, 36);\n  background: radial-gradient(\n    circle,\n    rgba(2, 0, 36, 1) 0%,\n    rgba(63, 148, 0, 1) 0%,\n    rgba(0, 108, 39, 1) 100%\n  );\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
